(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["how-to-play"]) return;
  try {
    
  const howToPlay = new Swiper('.how-to-play__swiper', {
    slidesPerView: 1.125,
    spaceBetween: 20,
    effect: 'slide',
    autoHeight: false,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
          crossFade: true
        },
      }
    }
  })

  const howToPlayDesktop = new Swiper('.how-to-play-desktop__swiper', {
    slidesPerView: 1,
    effect: 'fade',
    autoHeight: true,
    draggable: false,
    fadeEffect: {
      crossFade: true
    }
  })

  const howToPlayNav = document.querySelectorAll("button[data-how-to-play]")

  howToPlayNav.forEach( b => {
    b.addEventListener('click', (e) => {
      const button = e.target == 'button' ? e.target : e.target.closest("button")
      const slideId = button.dataset.index

      button.parentElement.querySelector(".active").classList.remove("active")

      howToPlay.slideTo(slideId)
      howToPlayDesktop.slideTo(slideId)
      button.classList.add("active")
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-block"]) return;
  try {
    
  const instagramSwiper = new Swiper('.instagram-block__images', {
    arrows: false,
    autoPlay: 500,
    slidesPerView: 2,
    spaceBetween: 12,
    breakpoints: {
      768: {
        enabled: false,
        slidesPerView: 5,
        spaceBetween: 30
      },
    },
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Main product slider
  const productSlider = new Swiper('.product-zoom-slider', {
    slidesPerView: 1.25,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.swiper-pagination'
    },
    navigation: {
      nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  });

  document.querySelector('#main-product').addEventListener( 'click', () => {
    if (event.target.matches('[data-product-zoom-trigger]')) {
		  MicroModal.show('product-zoom-modal')
      productSlider.slideTo(event.target.dataset.productZoomIndex)
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !window.DesignMode) return;
  try {
    

  const pressSwiper = new Swiper('.press-swiper', {
    slidesPerView: 1,
    effect: 'fade',
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    },
    loop: true
  })

  const pressTicker = new Swiper('.press-ticker', {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 6000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView:'auto',
  allowTouchMove: false,
  disableOnInteraction: true,
  on: {
    realIndexChange: function() {
      setTimeout(() => {
        pressSwiper.slideTo(this.realIndex, 100)
      }, 3000);      
    }
  }
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

})();
